import GameObject from '../../../GameObject/GameObject';
import AnimationClip from '../AnimationClip';
import {
    AwaitIterators,
    GetAnimationClip,
    PlayAnimation,
} from '../AnimationHelper';
import SpriteComponent from '../../../Component/Render/Sprite';
import { delay } from '../../../Utility/Task/TaskQueue';
import { UIEvent } from '../../UI/BaseUISystem';

export class BoosterShuffle extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        yield* delay(600);

        const foldDownAnimations = [];
        for (const target of meta.targets) {
            foldDownAnimations.push(
                PlayAnimation(
                    GetAnimationClip('CardFlip', target.card, {
                        faceUp: false,
                    })
                )
            );
        }

        yield* AwaitIterators(foldDownAnimations);

        const foldUpAnimations = [];
        for (const target of meta.targets) {
            // Set card textures.
            target.card
                .getChildByName('cardFrontSprite')
                .getComponent(
                    SpriteComponent
                ).texture = `card${target.newValue + 1}`;

            foldUpAnimations.push(
                PlayAnimation(
                    GetAnimationClip('CardFlip', target.card, {
                        faceUp: true,
                    })
                )
            );
        }

        yield* AwaitIterators(foldUpAnimations);
        meta.system.scene.emit(UIEvent.RESTORE_INTERACTIVITY, true);
    }
}
